export default __webpack_public_path__ + "static/media/bnk_venture.c6516ab8.bmp";